export const USER_DETAILS = "user_details"
export const IS_AUTH = "isAuth"
export const TOKEN = "token"
export const LOGIN_STATUS = "loginStatus"
export const VERIFIED = "verified"